
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/public/feature",
      function () {
        return require("private-next-pages/public/feature.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/public/feature"])
      });
    }
  